const getters = {
	token: state => state.user.token,
	isLogin: state => state.user.token ? true : false,
	userId: state => state.user.userId
}

export default getters